import * as THREE from 'three';
import Action from '../classes/Action';
import VisibilityManager from '../classes/VisibilityManager';
import { RenderModes, SaveModificationTypes } from '../globals';
import ProjectSaver from '../classes/ProjectSaver';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import MaterialAsset from '../classes/MaterialAsset';
import { VisibilityModes } from '../interfaces/enums';

export type ObjectPropertiesPasteActionValues = {
	standaloneVisibilityMode: VisibilityModes;
	deviceVisibilityMode: VisibilityModes;
	overrideParentVisibility: boolean;
	customStandaloneMaterial: string | undefined;
	customDeviceMaterial: string | undefined;
};

export default class ObjectPropertiesPasteAction extends Action
{
	constructor(objects: THREE.Object3D[], values: ObjectPropertiesPasteActionValues | ObjectPropertiesPasteActionValues[])
	{
		const newValues = Array(objects.length).fill(values);
		const oldValues: ObjectPropertiesPasteActionValues[] = [];
		for (const object of objects)
		{
			oldValues.push({
				standaloneVisibilityMode: object.userData.visibility[RenderModes.Standalone],
				deviceVisibilityMode: object.userData.visibility[RenderModes.Device],
				overrideParentVisibility: object.userData.visibility.overrideParent,
				customStandaloneMaterial: object.userData.visibility.customStandaloneMaterial,
				customDeviceMaterial: object.userData.visibility.customDeviceMaterial,
			});
		}
		super([objects, newValues], [objects, oldValues], "Paste Object Properties", [newValues, oldValues]);
	}

	do(objects: THREE.Object3D[], values: ObjectPropertiesPasteActionValues[]) : void
	{
		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			const visibilityValue = values[i];
			DefaultSceneManager.getInstance().syncVisibilityMode(object, visibilityValue.deviceVisibilityMode, RenderModes.Device, visibilityValue.customDeviceMaterial);
			DefaultSceneManager.getInstance().syncVisibilityMode(object, visibilityValue.standaloneVisibilityMode, RenderModes.Standalone, visibilityValue.customStandaloneMaterial);
			DefaultSceneManager.getInstance().syncVisibilityParentOverride(object, visibilityValue.overrideParentVisibility);
			
			object.userData.visibility.overrideParentVisibility = visibilityValue.overrideParentVisibility;
			object.userData.visibility[RenderModes.Device] = visibilityValue.deviceVisibilityMode;
			object.userData.visibility[RenderModes.Standalone] = visibilityValue.standaloneVisibilityMode;
			object.userData.visibility.customStandaloneMaterial =visibilityValue.customStandaloneMaterial;
			object.userData.visibility.customDeviceMaterial = visibilityValue.customDeviceMaterial;

			ProjectSaver.getInstance().markModifiedObject(objects[i], SaveModificationTypes.Visibility);
			VisibilityManager.setObjectsVisibilityMode([object], [object.userData.visibility[VisibilityManager.getRenderMode()]]);
			MaterialAsset.registerCustomMaterialReference(object);
		}
	}

	verify(newValues: ObjectPropertiesPasteActionValues[], oldValues: ObjectPropertiesPasteActionValues[]) : boolean
	{
		if (newValues.length !== oldValues.length) return false;

		for (let i = 0; i < newValues.length; i++)
		{
			if (JSON.stringify(newValues[i]) !== JSON.stringify(oldValues[i]))
			{
				return true;
			}
		}

		return false;
	}
}
